import React from 'react';
import { Globe, DollarSign, MapPin, ExternalLink } from 'lucide-react';

const ExportSupportSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  if (!formData.includeExportSupport) return null;

  return (
    <div className="mb-6 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Globe className="w-5 h-5 mr-2 text-amber-500" />
        Поддержка экспорта сельхозпродукции
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Выручка от экспорта */}
        <div>
          <label htmlFor="exportRevenue" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Выручка от экспорта
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <DollarSign className="h-4 w-4 text-gray-500 dark:text-gray-400" />
            </div>
            <input
              type="text"
              id="exportRevenue"
              name="exportRevenue"
              value={formData.exportRevenue}
              onChange={handleInputChange}
              className={`form-input w-full pl-9 ${errors.exportRevenue ? 'input-error' : ''}`}
              placeholder="Введите сумму экспортной выручки"
            />
          </div>
          {errors.exportRevenue && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.exportRevenue}
            </p>
          )}
        </div>

        {/* Страны экспорта */}
        <div>
          <label htmlFor="exportCountries" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <MapPin className="w-4 h-4 mr-1 text-amber-500" />
            Страны экспорта
          </label>
          <input
            type="text"
            id="exportCountries"
            name="exportCountries"
            value={formData.exportCountries}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.exportCountries ? 'input-error' : ''}`}
            placeholder="Введите страны через запятую"
          />
          {errors.exportCountries && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.exportCountries}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Например: china,belarus,kazakhstan
          </p>
        </div>
      </div>

      <div className="mt-4 bg-amber-100 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 dark:border-amber-800">
        <div className="flex items-start">
          <ExternalLink className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
              Информация о поддержке экспорта
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              Программы поддержки экспорта предусматривают компенсацию до 25% затрат, связанных с продвижением сельхозпродукции
              на зарубежные рынки. Дополнительная поддержка предоставляется при выходе на новые рынки или при экспорте
              продукции с высокой добавленной стоимостью. Количество стран экспорта влияет на размер поддержки.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportSupportSection;